import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.css';
import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import USER from './core/user/user-inforamtion';
import Loadable from 'react-loadable';
import Loading from './utils/loading/loading';
import { LocaleProvider } from 'antd';
import fa_IR from 'antd/lib/locale-provider/fa_IR';
import en_US from 'antd/lib/locale-provider/en_US';
import 'moment/locale/fa';
let locales;
if(localStorage.getItem('lang') === 'en')
  locales = en_US;
else locales = fa_IR;



const LoadableComponent = Loadable({
  loader: () => import('./App'),
  loading: Loading,
});


let user = new USER();
user.GET();

ReactDOM.render(<LocaleProvider locale={locales}><LoadableComponent/></LocaleProvider>, document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js